export default {
  MY_SCHEDULE_CARD: {
    TITLE: `Mon horaire`
  },
  PROJECT_INFO_MODAL: {
    TITLE: `Informations sur le projet`,
    SUMMARY: ``,
    PROJECT_NAME: `Nom:`,
    PROJECT_OWNERS: `Responsables de projet:`
  },
  NO_SHIFTS: `Aucun quart de travail`,
  NO_SHIFTS_TODAY: `Tu ne travailles pas aujourd'hui, prends ça relaxe 🏖`,
  PREVIOUS_WEEK: `Semaine précédente`,
  THIS_WEEK: `Cette semaine`,
  NEXT_WEEK: `Semaine suivante`,
  CREATE_ATTENDANCE_REQUEST: `Créer une requête d'absence`,
  LOADING_SHIFTS: `Chargement des quarts de travail`,
  SHIFT_OPTIONS: `Options du quart de travail`,
  SEE_MY_CO_WORKERS: `Voir qui travaille en même temps que moi`,
  ON_CALL: `Sur appel`,
  VIEW_COMMENT: `Voir les informations supplémentaires`,
  ADDITIONAL_INFORMATION: `Informations supplémentaires`,
  PUNCH_INFORMATION: `Informations de poinçon`,
  TIME_OFF: `Congé`,
  CO_WORKERS_MODAL: {
    TITLE: `Personnes qui travaillent en même temps que moi`,
    SUMMARY: ``
  },
  EXPORT_SCHEDULE: {
    TITLE: `Exporter l'horaire en PDF`,
    SUMMARY: `Choisissez un intervalle de dates pour l'exportation de votre horaire`
  },
  PDF_TITLE: `pdf_horaire_{{employee}}_{{ start }}-{{ end }}`,
  RANGE: {
    LABEL: `Dates`,
    PLACEHOLDER: `Choisissez un intervalle de dates`,
    DESCRIPTION: ``
  },
  SCHEDULE_HEADER: `Horaire de {{employee}} du {{ start }} au {{ end }}`
}
